module.exports = __webpack_public_path__ + "FixelDisplay-MediumItalic.f26ddca216757ebbed01.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelDisplay/FixelDisplay-MediumItalic.woff2
// module id = ./src/assets/webfonts/fixelDisplay/FixelDisplay-MediumItalic.woff2
// module chunks = styles